<template>
    <div class='line'  :data-word="ipObj.ip"  >
        <div :class="col1Class()" >{{ ipObj.ip }}</div>
        <div class="col col2">{{ getSetting(ipObj.settingId) }}</div>
        <div class="col col4">{{ ipObj.note }} &nbsp;</div>

        <button class="mdl-button mdl-js-button mdl-button--icon btn_editsub btnEdit" @click='clicEditIP()'><i class="material-icons">edit</i></button>
        <button class="mdl-button mdl-js-button mdl-button--icon btn_deletesub btnDelete" @click='clicDeleteIP()'><i class="material-icons">delete</i></button>
    </div>
</template>

<script>
    import axios from 'axios'
    import { diagonalbackURL, defaultConfig } from "../constantes";
    import FctUtils from '@/components/FctUtils';

    export default {
        name:"IPLine",
        props:{
            ipObj: {type:Object},
        },
        mixins: [FctUtils],
        data(){
            return {
                settings: {}
            }
        },
        created() {
            // Recuperation des configurations du client
            //
            axios(diagonalbackURL + "/clients/"+ this.$store.getters.currentClientId+"/settings",  defaultConfig)
            .then(reponse => {
                this.settings = reponse.data;
            })
            .catch(error => this.errorHandler(error));
        },
        methods : {
            col1Class() {
                var result = 'col col1 ';
                result +=  (this.ipObj.active)? 'green' : 'red'
                return result;
            },
            getSetting(settingId) {
                var array = this.settings;

                for (var i = 0; i < array.length; i++) {
                    if (array[i].id == settingId) return array[i].name;
                }

                return "ERROR Configuration non définie"
            }, 
            clicDeleteIP() {
                this.emitter.emit('showPLForm', {mode:'formIP_remove', data:this.ipObj});
            },
            clicEditIP() {
                this.emitter.emit('showPLForm', {mode:'formIP_edit', data:this.ipObj});
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.pl-list .line {
    position:relative;
    width : 100%;
}

.btnEdit {
    position: absolute;
    top: 5px;
    right: 25px;
    color: #0075bb;
}

.btnDelete {
    position: absolute;
    top: 5px;
    right: 5px;
}

</style>
